import { Javascript, ReactLogo } from "@styled-icons/boxicons-logos";

import { Ruby } from "@styled-icons/octicons";
import { Adobeillustrator } from "@styled-icons/simple-icons";
export const categories = [
  {
    id: 1,
    name: "Ruby Projects",
    path: "Ruby",
    bgcolor: "#fad2e1",
    icon: <Ruby />,
  },
  {
    id: 2,
    name: "Javascript Projects",
    path: "Javascript",
    bgcolor: "#fff1e6",
    icon: <Javascript />,
  },
  {
    id: 3,
    name: "React Projects",
    path: "React",
    bgcolor: "#dfe7fd",
    icon: <ReactLogo />,
  },
  {
    id: 4,
    name: "Graphic Design",
    path: "Design",
    bgcolor: "#eae4e9",
    icon: <Adobeillustrator />,
  },
];
